var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoolBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.09,13.31a.33.33,0,0,0,.07.13.32.32,0,0,0,.21.13l4.23.76a.35.35,0,0,0,.28-.07A.4.4,0,0,0,16,14l.25-4.29a.35.35,0,0,0-.57-.3l-.9.71c-.89-.67-4.15-2.64-8.13.51a.34.34,0,0,0-.1.44l0,.06a.35.35,0,0,0,.38.12,5,5,0,0,1,5,1.05l-.81.64A.35.35,0,0,0,11.09,13.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.12,6a5.07,5.07,0,0,0-.55,0,6.67,6.67,0,0,1,.64,1.87,5,5,0,0,1-.09,10,3.58,3.58,0,0,1-.81-.07h-.23l-2.45.87V16.41l-.28-.27c-.15-.19-.28-.39-.41-.59A6.81,6.81,0,0,1,9,16a7.25,7.25,0,0,0,.71,1.09v4.22l4.52-1.64a4,4,0,0,0,.87.07A6.88,6.88,0,1,0,15.12,6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.23,14.39A1.17,1.17,0,0,1,10.5,14a1.4,1.4,0,0,1-.22-.44v0a4.76,4.76,0,0,1-1.82.35,3.22,3.22,0,0,1-.77-.07H7.48l-2.31.83v-2.1l-.25-.26A4.69,4.69,0,0,1,8.46,4.47a4.62,4.62,0,0,1,4.6,3.87,7.21,7.21,0,0,1,1.7.75L14.91,9A6.46,6.46,0,0,0,2,9.15a6.23,6.23,0,0,0,1.39,4v4l4.25-1.53a4.06,4.06,0,0,0,.82.06A6.38,6.38,0,0,0,12,14.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoolBall);
export default __webpack_public_path__ + "static/media/wool-ball.62bb2d0cbe022ad10062c1d54a259c91.svg";
export { ForwardRef as ReactComponent };